// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--hC7C1","vas_item":"a10a3f92e9--vas_item--Lt2gY"};